
import { useEffect, useState, useCallback } from "react";
import { Bell, CheckCircle, XCircle, Info, AlertCircle } from "lucide-react";
import "../../../StyleSheet/MainComponent/User/Notificationscreen.scss"
import closepopup from "../../../Assets/AppComponent/Group 442 (1).svg";
import { useDispatch, useSelector } from "react-redux";
import { setthenotificationactionsgetlist, setthenotificationactionDeletelist, gettheSideBarNotificationState } from "../../../Redux/Slice"
import Dusbinimages from "../../../Assets/AppComponent/Group 427320197 (1).svg"
import notifyimg from "../../../Assets/AppComponent/Vector (5).svg"
import notreeds from "../../../Assets/AppComponent/Group 421.svg"
import { useInView } from "react-intersection-observer";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const notifications = [
  { id: 1, type: "success", message: "Profile updated successfully", time: "2m ago" },
  { id: 2, type: "error", message: "Failed to process payment", time: "10m ago" },
  { id: 3, type: "info", message: "New feature added: Dark Mode", time: "1h ago" },
  { id: 4, type: "warning", message: "Password expires in 3 days", time: "2h ago" },
];

const icons = {
  success: <CheckCircle className="text-green-500" />,
  error: <XCircle className="text-red-500" />,
  info: <Info className="text-blue-500" />,
  warning: <AlertCircle className="text-yellow-500" />,
};

export default function NotificationScreen(props) {
  const { show, setshow } = props;
  const state = useSelector((state) => state)
  const dispatch = useDispatch()
  const [notifs, setNotifs] = useState(notifications);

  const [page, setPage] = useState(1); // Track page number
  const [loading, setLoading] = useState(false); // Loading state
  const [hasMore, setHasMore] = useState(true); // Check if more data exists
  const { ref, inView } = useInView(); // Track visibility of last element

  const [pageData, setPageData] = useState(state.NotificationListoutapidatahold.Total_counts /10);

  const markAsRead = (id) => {
    console.log(id, "sdaspids id");

    const payload = {
      Deleteid: id
    }
    dispatch(setthenotificationactionDeletelist(payload))
    setNotifs(notifs.filter((n) => n.id !== id));
  };
  useEffect(() => {
    const payload = {
      user: state.SideBarFiles.LoginIDs,
      page:page,
      page_size: 10,

    }
    dispatch(setthenotificationactionsgetlist(payload))
  }, [page])
  console.log(state.NotificationListoutapidatahold.Total_counts, "NotificationListoutapidatahold.Total_counts",page);

  const pageCount = () => {
    if (page < pageData) {
      setPage(page + 1);
    } else {
      toast.warn("Reached Total message");
    }
  };

  useEffect(() => {
    if (state.NotificationListoutapidatahold.NotificationListoutDatas) {
      setPageData(state.NotificationListoutapidatahold.Total_counts / 10);
    }
  }, [state.NotificationListoutapidatahold.NotificationListoutDatas, page]);


  console.log(state.NotificationListoutapidatahold.NotificationListoutDatas, "NotificationListoutDatas");

  const formatedDateListwithtime = (dateString) => {
    const date = new Date(dateString);

    // Options for date formatting (only date)
    const dateOptions = {
      month: "short", // e.g., Dec
      day: "2-digit", // e.g., 22
      year: "numeric", // e.g., 2024
    };

    // Options for time formatting (only time)
    const timeOptions = {
      hour: "2-digit", // e.g., 02
      minute: "2-digit", // e.g., 16
      hour12: true, // e.g., AM/PM format
    };

    // Format the date and time separately
    const formattedDate = date.toLocaleDateString("en-US", dateOptions);
    const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

    // Combine the formatted date and time
    return `${formattedDate}-${formattedTime}`;
  };




  return (
    <div className="notification-wrapper">
      <div className="notification-container">
        <div className="header">
          <h2>Notifications</h2>
          <img src={closepopup} alt="" className="Closepopup Closepopuphide" onClick={() => {
            dispatch(gettheSideBarNotificationState(false));
            show && setshow(!show)
          }} />

        </div>


        <div className="notification-list">
          {state.NotificationListoutapidatahold.NotificationListoutDatas.length === 0 ? (
            <p className="no-notifications">No new notifications</p>
          ) : (
            state.NotificationListoutapidatahold.NotificationListoutDatas.map((notif) => (
              <>

                <div key={notif.id} className="notification-card">

                  <div className="notification-content">
                    <h4 className="notification-title">
                      <img src={notif.viewed ? notifyimg : notreeds} />

                      {notif.title}</h4>
                    <p className="notification-body">{notif.body}</p> {/* Displaying body */}
                    <span className="time-stamp">{formatedDateListwithtime(notif.created_date)}</span>

                  </div>
                  <button className="dismiss-btn" onClick={() => markAsRead(notif.id)}>
                    <img src={Dusbinimages} />
                  </button>
                </div>


              </>

            ))
          )}
        </div>
        {page < pageData ? null : 
        <div className="paginationBtn" onClick={pageCount}>
          <button className="readMore">Read More</button>
        </div>
}
      </div>
    </div >
  );
}
